import MediaQuery from 'react-responsive';
import classnames from 'classnames';
import Button from 'ui/common/button';
import React from 'react';

// import AnimatedBackground from "components/animated-background/desktop-version";
// import Button from "components/common/button";

import styles from './index.module.scss';

const Hero = () => {
  const renderDesktop = () => {
    return (
      <div className={classnames(styles.hero, 'mt-5')}>
        <div className="d-flex align-items-center justify-content-between">
          <div className="col-5 px-0 mt-0">
            <h1 className={classnames(styles.heroTitle, 'mt-3 mx-auto text-left mb-0')}>
              <span className={styles.bold}>Indorse</span> 2.0
            </h1>
            <div className="my-3 py-1">
              <h3 className={styles.heroSubTitle}>The Indorse Ecosystem Reinvented</h3>
              <h3 className={styles.heroSubTitle}>
                <i style={{ color: '#00B2A4' }} className="mr-2 fa fa-check-circle" />
                Anonymous Indorsement Protocol (AIP) v2 launch
              </h3>
              <h3 className={styles.heroSubTitle}>
                <i style={{ color: '#00B2A4' }} className="mr-2 fa fa-check-circle" />
                New roles in the ecosystem
              </h3>
              {/* <h3 className={styles.heroSubTitle}>
                <i
                  style={{ color: "#00B2A4" }}
                  className="mr-2 fa fa-check-circle"
                />
                Launch of the Indorse DAO in Q1 2021
              </h3> */}
            </div>
            <div>
              <Button
                color="primary-rect"
                href="https://indorse-staging-bucket.s3.amazonaws.com/Indorse+2.0+Light+Paper.pdf"
              >
                Check out the lightpaper
              </Button>
            </div>
          </div>
          <div className="px-0 mt-3 col-7">
            <img
              src="https://indorse-staging-bucket.s3.amazonaws.com/New_Hero_Image.png"
              width="500"
              className="ml-auto"
              alt="hero"
            />
          </div>
        </div>
      </div>
    );
  };

  const renderMobile = () => {
    return (
      <div className={classnames(styles.hero, 'mt-4')}>
        <div>
          <div className="px-0">
            <h1 className={classnames(styles.heroTitle, 'mt-3 mx-auto text-center mb-0')}>
              <span className={styles.bold}>Indorse</span> 2.0
            </h1>
            <div className="my-4 text-left">
              <h3 className={styles.heroSubTitle}>The Indorse Ecosystem Reinvented</h3>
              <h3 className={styles.heroSubTitle}>
                <i style={{ color: '#00B2A4' }} className="mr-2 fa fa-check-circle" />
                Anonymous Indorsement Protocol (AIP) v2 launch
              </h3>
              <h3 className={styles.heroSubTitle}>
                <i style={{ color: '#00B2A4' }} className="mr-2 fa fa-check-circle" />
                New roles in the ecosystem
              </h3>
              {/* <h3 className={styles.heroSubTitle}>
                <i
                  style={{ color: "#00B2A4" }}
                  className="mr-2 fa fa-check-circle"
                />
                More involved community
              </h3> */}
            </div>
            <div className="d-flex justify-content-center">
              <Button
                href="https://indorse-staging-bucket.s3.amazonaws.com/Indorse+2.0+Light+Paper.pdf"
                color="primary-rect"
              >
                Check out the lightpaper
              </Button>
            </div>
          </div>
          <div className="px-0 mt-3">
            <img
              src="https://indorse-staging-bucket.s3.amazonaws.com/New_Hero_Image.png"
              width="360px"
              className="mx-auto"
              alt="hero"
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={classnames(styles.heroCompany, 'page-max-width')}>
      <MediaQuery minWidth={'992px'}>
        {/* <AnimatedBackground /> */}
        {renderDesktop()}
      </MediaQuery>
      <MediaQuery maxWidth={'991px'}>{renderMobile()}</MediaQuery>
    </div>
  );
};

export default Hero;
